"use client"
import type React from "react"
import { createContext, useMemo } from "react"
import type { TableSize } from "./constants"

export const TableContext = createContext<{
  size: TableSize
  dividers?: boolean
}>({
  size: "md",
  dividers: false,
})

type Props = {
  size: TableSize
  dividers?: boolean
  children: React.ReactNode
}

export const TableProvider = ({ size, dividers, children }: Props) => {
  const value = useMemo(() => ({ size, dividers }), [size, dividers])

  return <TableContext.Provider value={value}>{children}</TableContext.Provider>
}
